import { useStore, useUnit } from 'effector-react'

import {
  $copytradeHistory,
  $totalCountOfCopytradeHistory,
  getCopytradeHistory,
  copytradeHistoryMounted,
  $errorCopytradeHistoryRequest,
} from './model'
import { CopytradeHistoryRequest } from './types'

export const useCopytradeHistoryWidget = () => {
  const onChangeCopytradeHistoryList = ({
    limit,
    page,
    filters,
  }: CopytradeHistoryRequest) => {
    copytradeHistoryMounted({
      limit,
      page,
      filters,
    })
  }
  const copytradeHistory = useStore($copytradeHistory)
  const totalCountOfCopytradeHistory = useStore($totalCountOfCopytradeHistory)
  const errorCopytradeHistoryRequest = useUnit($errorCopytradeHistoryRequest)

  const loading = useStore(getCopytradeHistory.pending)

  return {
    copytradeHistory,
    loading,
    totalCountOfCopytradeHistory,
    onChangeCopytradeHistoryList,
    errorCopytradeHistoryRequest,
  }
}
